import { type RenewalType } from '../models/RenewalType'

export const renewalTypes: RenewalType[] = [
  {
    id: 1,
    name: 'Miudiño',
    price: 0,
    renovation: true,
    newMember: true
  },
  {
    id: 2,
    name: 'Neno (10 a 16 anos)',
    price: 15,
    renovation: true,
    newMember: true
  },
  {
    id: 3,
    name: 'Adulto',
    price: 20,
    renovation: true,
    newMember: false
  },
  {
    id: 4,
    name: 'Alta + Bufanda',
    price: 30,
    renovation: false,
    newMember: true
  }
]

export const getRenewalTypeById = (id: number): RenewalType => {
  return renewalTypes.find(renewalType => renewalType.id.toLocaleString() === id.toLocaleString()) as RenewalType
}
